import { memo, useEffect, useState } from "react";
import styled from "styled-components";
import { ProjectAPIs } from "~/common/typescript/apis/ProjectAPIs";
import ACProjectItem from "./ACProjectItem";
import { AC_Project_Base } from "~/common/typescript/services/access_control/AC_Project";

const SharedACProjectList = () => {
  const [items, setItems] = useState<AC_Project_Base[]>([]);
  useEffect(() => {
    ProjectAPIs.remote_getProjectsSharedWithMe()
      .then((acProjects) => {
        setItems(Array.isArray(acProjects) ? acProjects : []);
      })
      .catch((err) => {
        console.error('Error fetching shared projects:', err);
        setItems([]);
      });
  }, []);

  return (
    <UI_Wrapper>
      <UI_Header>
        <UI_TitleRow>
          <UI_Title>Dự án được chia sẻ với tôi</UI_Title>
          {items.length > 0 && <UI_Badge>{items.length}</UI_Badge>}
        </UI_TitleRow>
      </UI_Header>

      <UI_List>
        {items.length > 0 &&
          items.map((project) => {
            return <ACProjectItem key={project.id!} acProject={project} />;
          })}
      </UI_List>

      {items.length === 0 && (
        <div style={{ padding: 12, textAlign: 'center', color: '#94a3b8' }}>
          Không có dự án nào được chia sẻ
        </div>
      )}
    </UI_Wrapper>
  );
};

export default memo(SharedACProjectList);

const UI_Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #f1f5f9;

  @media (max-width: 768px) {
    padding: 12px;
    gap: 8px;
  }

  @media (max-width: 480px) {
    padding: 8px;
    gap: 6px;
    border-radius: 6px;
  }
`;

const UI_Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const UI_TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const UI_Title = styled.h2`
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
`;

const UI_Badge = styled.span`
  background: #f1f5f9;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
`;

const UI_List = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 10px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 8px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 6px;
  }
`
